interface TypographyProps {
    children: React.ReactNode;
    className?: string;
}

export const BodySmallRegular = ({ children, className = '' }: TypographyProps) => {
    return (
        <p className={`font-outfit text-xs lg:text-sm font-normal leading-5 ${className}`}>
            {children}
        </p>
    );
};